// Styles
import './article-image-slider.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initArticleImageSlider = (context) => {
  const imageSliderSection = context.closest('.shopify-section');
  if (!imageSliderSection) return;

  const slider = imageSliderSection.querySelector('.article-image-slider__gallery');
  if (!slider) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });
  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.2; //scroll-fast
    slider.scrollLeft = scrollLeft - walk;
  });
};

if (document.readyState != 'loading') {
  [].forEach.call(
    document.querySelectorAll('.article-image-slider__container'),
    (el) => {
      window.dAgency.initArticleImageSlider(el);
    },
  );
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(
      document.querySelectorAll('.article-image-slider__container'),
      (el) => {
        window.dAgency.initArticleImageSlider(el);
      },
    );
  });
}

